import React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

import { Box, TagColor as Color, Text } from '@factorialco/deprecated-design-system'
import { ApprovalsGroupFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const ApprovalGroupPage = () => {
  const { group } = useOutletContext<{ group: ApprovalsGroupFragment }>()

  const statusProps = group?.default
    ? {
        status: {
          label: i18n.t('settings.approvals.detail.default_tag'),
          type: Color.viridian,
        },
      }
    : null

  return (
    <ResponsivePage.Body widget={<Text.Normal>{group?.description}</Text.Normal>} {...statusProps}>
      <Box>
        <Outlet context={{ group }} />
      </Box>
    </ResponsivePage.Body>
  )
}

export default ApprovalGroupPage
